import { sharedQuestions } from './nationwideAppSharedQuestions';
import { sharedSections } from './nationwideAppSharedSections';
import { FundingPolicyType } from '@shared';
import { nationwideSharedDefs } from './nationwideSharedDefs';
import { nationwidePreApplicationFormDefinition } from '@shared/policy-application/nationwidePreApplicationFormDef';

const questions: Record<string, PolicyFormQuestion> = {
  ...sharedQuestions,

  /* Section 14 - Tobacco and Nicotine Use */
  tobaccoPrimary: {
    id: 'tobacco-primary',
    questionRef: 'tobaccoPrimary',
    title: 'Primary Insured: Have you used tobacco or nicotine in any form in the last 12 months?',
    required: true,
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes'},
      { id: 'no', value: 'No'}
    ]
  },
  tobaccoAdditional: {
    id: 'tobacco-additional',
    questionRef: 'tobaccoAdditional',
    title: 'Additional Insured: Have you used tobacco or nicotine in any form in the last 12 months?',
    required: true,
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes'},
      { id: 'no', value: 'No'}
    ]
  },

  /* Section 15 - Insurance Information - Primary Insured */
  primaryInsuredAcceleratedDeath: {
    id: 'primary-insured-accel-death',
    questionRef: 'primaryInsuredAcceleratedDeath',
    title: 'The policy being applied for may be issued with one or more accelerated death benefits. Is it intended to replace any long-term care insurance presently in force?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  /* Section 15 - Insurance Information - Additional Insured */
  additionalInsuredAcceleratedDeath: {
    id: 'additional-insured-accel-death',
    questionRef: 'additionalInsuredAcceleratedDeath',
    title: 'The policy being applied for may be issued with one or more accelerated death benefits. Is it intended to replace any long-term care insurance presently in force?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  /* Section 25 - Health Conditions - Primary Insured */
  primaryDiabetes: {
    id: 'primary-diabetes',
    questionRef: 'primaryDiabetes',
    title: 'Primary Insured: Have you in the past 7 years, been treated or diagnosed by a member of the medical profession as having diabetes?',
    required: true,
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes'},
      { id: 'no', value: 'No'}
    ]
  },
  primaryStroke: {
    id: 'primary-stroke',
    questionRef: 'primaryStroke',
    title: 'Primary Insured: Have you in the past 7 years, been treated or diagnosed by a member of the medical profession as having stroke?',
    required: true,
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes'},
      { id: 'no', value: 'No'}
    ]
  },
  primaryCancer: {
    id: 'primary-cancer',
    questionRef: 'primaryCancer',
    title: 'Primary Insured: Have you in the past 7 years, been treated or diagnosed by a member of the medical profession as having cancer?',
    required: true,
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes'},
      { id: 'no', value: 'No'}
    ]
  },
  primaryHeartDisease: {
    id: 'primary-heart-disease',
    questionRef: 'primaryHeartDisease',
    title: 'Primary Insured: Have you in the past 7 years, been treated or diagnosed by a member of the medical profession as having heart disease?',
    required: true,
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes'},
      { id: 'no', value: 'No'}
    ]
  },
  primaryAlzheimers: {
    id: 'primary-alzheimers',
    questionRef: 'primaryAlzheimers',
    title: 'Primary Insured: Have you in the past 7 years, been treated or diagnosed by a member of the medical profession as having Alzheimer\'s Disease?',
    required: true,
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes'},
      { id: 'no', value: 'No'}
    ]
  },
  primaryDementia: {
    id: 'primary-dementia',
    questionRef: 'primaryDementia',
    title: 'Primary Insured: Have you in the past 7 years, been treated or diagnosed by a member of the medical profession as having dementia?',
    required: true,
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes'},
      { id: 'no', value: 'No'}
    ]
  },
  primaryAlcoholism: {
    id: 'primary-alcoholism',
    questionRef: 'primaryAlcoholism',
    title: 'Primary Insured: Have you in the past 7 years, been treated or diagnosed by a member of the medical profession as having alcoholism?',
    required: true,
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes'},
      { id: 'no', value: 'No'}
    ]
  },
  primaryDrugAbuse: {
    id: 'primary-drug-abuse',
    questionRef: 'primaryDrugAbuse',
    title: 'Primary Insured: Have you in the past 7 years, been treated or diagnosed by a member of the medical profession as having drug abuse?',
    required: true,
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes'},
      { id: 'no', value: 'No'}
    ]
  },
  primaryKidneyDisease: {
    id: 'primary-kidney-disease',
    questionRef: 'primaryKidneyDisease',
    title: 'Primary Insured: Have you in the past 7 years, been treated or diagnosed by a member of the medical profession as having kidney disease?',
    required: true,
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes'},
      { id: 'no', value: 'No'}
    ]
  },
  primaryAIDS: {
    id: 'primary-aids',
    questionRef: 'primaryAIDS',
    title: 'Primary Insured: Have you in the past 7 years, been treated or diagnosed by a member of the medical profession as having Acquired Immune Deficiency Syndrome (AIDS)?',
    required: true,
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes'},
      { id: 'no', value: 'No'}
    ]
  },

  /* Section 25 - Health Conditions - Additional Insured */
  additionalDiabetes: {
    id: 'additional-diabetes',
    questionRef: 'additionalDiabetes',
    title: 'Additional Insured: Have you in the past 7 years, been treated or diagnosed by a member of the medical profession as having diabetes?',
    required: false,
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes'},
      { id: 'no', value: 'No'}
    ]
  },
  additionalStroke: {
    id: 'additional-stroke',
    questionRef: 'additionalStroke',
    title: 'Additional Insured: Have you in the past 7 years, been treated or diagnosed by a member of the medical profession as having stroke?',
    required: false,
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes'},
      { id: 'no', value: 'No'}
    ]
  },
  additionalCancer: {
    id: 'additional-cancer',
    questionRef: 'additionalCancer',
    title: 'Additional Insured: Have you in the past 7 years, been treated or diagnosed by a member of the medical profession as having cancer?',
    required: false,
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes'},
      { id: 'no', value: 'No'}
    ]
  },
  additionalHeartDisease: {
    id: 'additional-heart-disease',
    questionRef: 'additionalHeartDisease',
    title: 'Additional Insured: Have you in the past 7 years, been treated or diagnosed by a member of the medical profession as having heart disease?',
    required: false,
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes'},
      { id: 'no', value: 'No'}
    ]
  },
  additionalAlzheimers: {
    id: 'additional-alzheimers',
    questionRef: 'additionalAlzheimers',
    title: 'Additional Insured: Have you in the past 7 years, been treated or diagnosed by a member of the medical profession as having Alzheimer\'s Disease?',
    required: false,
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes'},
      { id: 'no', value: 'No'}
    ]
  },
  additionalDementia: {
    id: 'additional-dementia',
    questionRef: 'additionalDementia',
    title: 'Additional Insured: Have you in the past 7 years, been treated or diagnosed by a member of the medical profession as having dementia?',
    required: false,
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes'},
      { id: 'no', value: 'No'}
    ]
  },
  additionalAlcoholism: {
    id: 'additional-alcoholism',
    questionRef: 'additionalAlcoholism',
    title: 'Additional Insured: Have you in the past 7 years, been treated or diagnosed by a member of the medical profession as having alcoholism?',
    required: false,
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes'},
      { id: 'no', value: 'No'}
    ]
  },
  additionalDrugAbuse: {
    id: 'additional-drug-abuse',
    questionRef: 'additionalDrugAbuse',
    title: 'Additional Insured: Have you in the past 7 years, been treated or diagnosed by a member of the medical profession as having drug abuse?',
    required: false,
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes'},
      { id: 'no', value: 'No'}
    ]
  },
  additionalKidneyDisease: {
    id: 'additional-kidney-disease',
    questionRef: 'additionalKidneyDisease',
    title: 'Additional Insured: Have you in the past 7 years, been treated or diagnosed by a member of the medical profession as having kidney disease?',
    required: false,
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes'},
      { id: 'no', value: 'No'}
    ]
  },
  additionalAIDS: {
    id: 'additional-aids',
    questionRef: 'additionalAIDS',
    title: 'Additional Insured: Have you in the past 7 years, been treated or diagnosed by a member of the medical profession as having Acquired Immune Deficiency Syndrome (AIDS)?',
    required: false,
    type: 'radio',
    options: [
      { id: 'yes', value: 'Yes'},
      { id: 'no', value: 'No'}
    ]
  },

  /* Section 23 - Receipt of Form Acknowledgment */
  receiptOfForms: {
    id: 'receipt-of-forms',
    questionRef: 'receiptOfForms',
    title: 'Please check forms that have been delivered and received:',
    type: 'multiselect',
    required: false,
    options: [
      { id: 'ooc', value: 'Outline of Coverage'},
      { id: 'hicap', value: 'Health Insurance Counseling and Advocacy Program (HICAP Notice)'},
      { id: 'tommorow', value: 'Taking Care of Tomorrow: A Consumer\'s Guide to Long-Term Care'},
      { id: 'replacement', value: 'Notice to Applicant Regarding Replacement of Accident and Sickness or Long-Term Care Insurance'},
      { id: 'lapse', value: 'Protection Against Unintended Lapse'},
      { id: 'ltc-worksheet', value: 'LTC Insurance Personal Worksheet'},
    ]
  },

  ltcInflationProtection: {
    id: 'ltc-inflation-protection',
    questionRef: 'ltcInflationProtection',
    title: 'Long-Term Care Inflation Protection Option',
    type: 'radio',
    required: true,
    options: [
      { id: '5-compound', value: '5% Compound Interest Inflation Protection' },
      { id: '3-compound', value: '3% Compound Interest Inflation Protection' },
      { id: '3-simple', value: '3% Simple Interest Inflation Protection' },
      // NOTE: If this id is ever changed we'd need to update it in evaluateConditionalRequirement
      { id: 'reject-all', value: ' I hereby REJECT all inflation benefit options' },
    ],
    format: 'vertical',
    minRows: 1,
    maxRows: 5,
  },
}

export const nationwideCareMattersCAFormDefinition: PolicyFormDefinition = {
  requiredParameters: nationwideSharedDefs.requiredParameters,

  sections: [
    ...nationwidePreApplicationFormDefinition.sections,
      sharedSections.proposedInsured,
      sharedSections.proposedAdditionalInsured,
      sharedSections.policyOwner,
      sharedSections.jointOwner,
      sharedSections.contingentOwner,
      sharedSections.payor,
      sharedSections.beneficiary,
      sharedSections.premiumBilling,
      sharedSections.caremattersIIPlan,
      sharedSections.caremattersTogetherPlan,
      sharedSections.taxpayerCertification,
      sharedSections.electronicDelivery,
      /* 14 ▸ Tobacco & Nicotine ---------------------------------------------- */
      {
        id: 'tobacco-nicotine',
        title: 'Tobacco & Nicotine',
        subsections: [
          {
            id: 'tobacco',
            title: 'Usage',
            questionGroups: [
              {
                id: 'usage',
                format: 'default',
                questions: ['tobaccoPrimary', 'tobaccoAdditional']
              }
            ]
          }
        ]
      },
      /* 13 ▸ Insurance Information --------------------------------------------- */
      {
        id: 'insurance-information',
        title: 'Insurance Information',
        subsections: [
          {
            id: 'primary-insured-insurance',
            title: 'Primary Insured Insurance History',
            questionGroups: [
              {
                id: 'primary-accel-death',
                format: 'default',
                questions: ['primaryInsuredAcceleratedDeath'],
              },
              {
                id: 'primary-current-insurance',
                format: 'default',
                questions: ['primaryInsuredOtherInsurance', 'primaryInsuredSoldPolicy', 'primaryInsuredRecentApplications'],
              },
              {
                id: 'primary-replacement',
                format: 'default',
                questions: ['primaryInsuredReplacement', 'primaryInsuredPastInsurance'],
              },
              {
                id: 'primary-ltc-coverage',
                format: 'default',
                questions: ['primaryInsuredOtherLtc', 'primaryInsuredTerminatedLtc', 'primaryInsuredMedicaid'],
              },
              {
                id: 'primary-intentions',
                format: 'default',
                questions: ['primaryInsuredIntendToStop', 'primaryInsuredReplaceMedical'],
              },
            ],
          },
        ],
      },

      /* 13 ▸ Insurance Information Additional Insured --------------------------------------------- */
      {
        id: 'insurance-information-additional-insured',
        title: 'Insurance Information for Additional Insured',
        conditional: {
          visible: {
            field: 'fundingPolicyType',
            operator: 'equals' as const,
            value: FundingPolicyType.jointCareMatters,
          },
        },
        subsections: [
          {
          id: 'additional-insured-insurance',
          title: 'Additional Insured Insurance History',
          questionGroups: [
            {
                id: 'additional-accel-death',
                format: 'default',
                questions: ['additionalInsuredAcceleratedDeath'],
              },
            {
              id: 'additional-current-insurance',
              format: 'default',
              questions: ['additionalInsuredOtherInsurance', 'additionalInsuredSoldPolicy', 'additionalInsuredRecentApplications'],
            },
            {
              id: 'additional-replacement',
              format: 'default',
              questions: ['additionalInsuredReplacement', 'additionalInsuredPastInsurance'],
            },
            {
              id: 'additional-ltc-coverage',
              format: 'default',
              questions: ['additionalInsuredOtherLtc', 'additionalInsuredTerminatedLtc', 'additionalInsuredMedicaid'],
            },
            {
              id: 'additional-intentions',
              format: 'default',
              questions: ['additionalInsuredIntendToStop', 'additionalInsuredReplaceMedical'],
            },
          ],
        },
        ],
      },

      /* 13 ▸ Insurance Information Table --------------------------------------------- */
      {
        id: 'insurance-information-table',
        title: 'Insurance Information Table',
        subsections: [
          {
            id: 'insurance-coverage-table',
            title: 'Insurance Coverage Details',
            questionGroups: [
              {
                id: 'coverage-table',
                format: 'default',
                questions: ['insuranceCoverageDetails'],
              },
            ],
          },
        ],
      },
      sharedSections.financialInformation,
      sharedSections.specialInstructions,
      sharedSections.financialProfessional,
      sharedSections.formAcknowledgment,
      /* 18 ▸ Temporary Insurance Agreement ------------------------------------- */
      {
        id: 'temporary-insurance',
        title: 'Temporary Insurance Agreement',
        subsections: [
          {
            id: 'temp-insurance-payment',
            title: 'Payment Information',
            questionGroups: [
              {
                id: 'temp-payment',
                format: 'inline',
                questions: ['tempInsurancePayment', 'tempInsuranceBaseAmount'],
              },
            ],
          },
        ],
      },
      /* 25 ▸ Health Conditions ---------------------------------------------- */
      {
        id: 'health-conditions',
        title: 'Health Conditions',
        subsections: [
          {
            id: 'primary-health-conditions',
            title: 'Primary Insured Health History',
            questionGroups: [
              {
                id: 'primary-conditions-1',
                format: 'default',
                questions: [
                  'primaryDiabetes',
                  'primaryStroke',
                  'primaryCancer',
                  'primaryHeartDisease',
                  'primaryAlzheimers'
                ]
              },
              {
                id: 'primary-conditions-2',
                format: 'default',
                questions: [
                  'primaryDementia',
                  'primaryAlcoholism',
                  'primaryDrugAbuse',
                  'primaryKidneyDisease',
                  'primaryAIDS'
                ]
              }
            ]
          },
          {
            id: 'additional-health-conditions',
            title: 'Additional Insured Health History',
            conditional: {
                  visible: {
                    field: 'fundingPolicyType',
                    operator: 'equals' as const,
                    value: FundingPolicyType.jointCareMatters,
                  },
                },
            questionGroups: [
              {
                id: 'additional-conditions-1',
                format: 'default',
                questions: [
                  'additionalDiabetes',
                  'additionalStroke',
                  'additionalCancer',
                  'additionalHeartDisease',
                  'additionalAlzheimers'
                ]
              },
              {
                id: 'additional-conditions-2',
                format: 'default',
                questions: [
                  'additionalDementia',
                  'additionalAlcoholism',
                  'additionalDrugAbuse',
                  'additionalKidneyDisease',
                  'additionalAIDS'
                ]
              }
            ]
          }
        ]
      },
    ],
  

  /* ---------- Question record -------------------------------------------------- */
  questions: {
    ...nationwidePreApplicationFormDefinition.questions,
    ...questions,
  },
};